import { useStore } from 'effector-react'
import {
  $totalCountOfWebsiteBannerItems,
  websiteBannersListMounted,
  getWebsiteBanners,
  $websiteBannerItems,
} from './model'
import { WebsiteBannersRequest } from './types'

export const useWebsiteBannersList = () => {
  const onChangeWebsiteBannersList = ({
    limit,
    page,
    filters,
  }: WebsiteBannersRequest) => {
    websiteBannersListMounted({
      limit,
      page,
      filters,
    })
  }

  const loading = useStore(getWebsiteBanners.pending)

  const websiteBannerItems = useStore($websiteBannerItems)
  const totalCountOfWebsiteBannerItems = useStore(
    $totalCountOfWebsiteBannerItems,
  )

  return {
    websiteBannerItems,
    totalCountOfWebsiteBannerItems,
    loading,
    onChangeWebsiteBannersList,
  }
}
